ACC.searchresultspopup = {
	
	showPopUp : function(){
		window.onload = function () {
		    (function () {
		        var resultsList = document.getElementById('resultsList');
		        if (resultsList) {
		        	
		        	var login_popup_wrapper = document.getElementById('login_popup_wrapper');
		        	if (login_popup_wrapper){
		        		if (localStorage.getItem("searchresultspopup_displayed") != "true"){
		        			$(login_popup_wrapper).show();
		        			$(login_popup_wrapper).delay(4000).fadeOut(1000);
		        			localStorage.setItem("searchresultspopup_displayed", "true");		        			
		        		}
		        	}
		        }
		    }());
		};
	}
};

$(document).ready(function() {
	ACC.searchresultspopup.showPopUp();
});
